var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-40px"},[(_vm.user && _vm.user.photo_url)?_c('img',{staticClass:"rounded overflow-hidden w-40px h-40px bg-light-primary",attrs:{"src":_vm.user.photo_url,"alt":''}}):_c('UserInitials',{attrs:{"name":_vm.user ? _vm.user.name : '?'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }